import {Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SupportService } from 'apps/app-cic-ciam/src/services/support.service';
import { ToastrService } from 'ngx-toastr';
import { STATE_TOKEN, StateModel } from '../../app.states';
import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { SmsEnrollResponse } from '../../app.actions';
import { SmsVerifyPopupComponent } from '../sms-verify-popup/sms-verify-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { phoneNumberWrapping } from '../../functions/utils';
import { OktaFactorService } from 'apps/app-cic-ciam/src/services/oktafactor.service';
import { EmailCodeMode } from '../../widgets/email-code/email-code.component';
import { SmsCodeMode } from '../../widgets/sms-code/sms-code.component';

@Component({
    selector: 'ciciam-choose-2fa-popup',
    templateUrl: './choose-2fa-popup.component.html',
    styleUrls: ['./choose-2fa-popup.component.scss']
})
export class Choose2faPopupComponent {
  showModal = false;

  courseId: string = '';
  courseName: string = '';
  coursePrice: number = 0;
  onSuccess?: () => Promise<any> = undefined;
  @Select(STATE_TOKEN) appState$!: Observable<StateModel>;
  // userId?: string;

  sms2faData: any;
  email2faData: any;

  emailForm: FormGroup = this.fb.group({
    email: ['', Validators.required],
  });
  phoneForm: FormGroup = this.fb.group({
    phoneNumber: ['', Validators.required],
  });

  @Output() emailVerify = new EventEmitter<any>();
  @Output() smsVerify = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();

  isLoading = false;

  @ViewChild('smsPopup') public smsPopup!: SmsVerifyPopupComponent;

  faEnvelope = faEnvelope;
  faPhone = faPhone;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private supportService: SupportService,
    private oktaFactorService: OktaFactorService,
    private store: Store,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    // this.appState$.subscribe((state) => {
    //   this.userId = state.userId;
    // });
  }

  requestPrompt(sms2faData: any, email2faData: any) {
    this.sms2faData = sms2faData;
    this.email2faData = email2faData;

    this.showModal = true;
  }

  onSelectEmail = ($event: any) => {
    this.emailVerify.emit();
    this.toggleModal();
  }

  onSelectSms = ($event: any) => {
    this.smsVerify.emit();
    this.toggleModal();
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  onCancel($event: any) {
    $event.preventDefault();
    this.toggleModal();
    this.cancel.emit();
  }
}
